export interface VideoItem {
  id: number;
  title: string;
  creator: string;
  category: string;
  duration: string;
  views: string;
  likes: string;
  cover: string;
  desc: string;
  badge?: string;
}

export interface StreamerItem {
  id: number;
  name: string;
  tagline: string;
  category: string;
  heat: number;
  followers: string;
  avatar: string;
  live: boolean;
  tags: string[];
}

export interface CollectionItem {
  id: number;
  title: string;
  count: string;
  desc: string;
  cover: string;
  badge: string;
  samples: string[];
}

export interface DiscussionItem {
  id: number;
  author: string;
  initial: string;
  title: string;
  board: string;
  excerpt: string;
  replies: number;
  likes: number;
  time: string;
}

export interface TagItem {
  id: number;
  label: string;
  count: string;
}

export interface GuideStep {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export interface FaqItem {
  id: number;
  q: string;
  a: string;
}

export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: '本站简介', href: '#intro' },
  { label: '热门推荐', href: '#hot' },
  { label: '福利主播', href: '#streamers' },
  { label: '无删减合集', href: '#collections' },
  { label: '观看指南', href: '#guide' },
  { label: '社区讨论', href: '#community' },
  { label: '常见问题', href: '#faq' },
];

export const stats = [
  { id: 1, value: '12,800+', label: '已收录作品', icon: 'ri-film-line' },
  { id: 2, value: '320+', label: '入驻主播', icon: 'ri-user-voice-line' },
  { id: 3, value: '200+', label: '每日更新', icon: 'ri-refresh-line' },
  { id: 4, value: '56,000+', label: '社区讨论', icon: 'ri-chat-smile-2-line' },
];

export const highlights = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '热门推荐每日更新',
    desc: '按播放与互动热度排序，早上打开就能看到当天最值得一看的新片，不再为「看什么」浪费时间。',
  },
  {
    id: 2,
    icon: 'ri-live-line',
    title: '福利主播实时榜单',
    desc: '综艺、音乐、游戏、美食等不同赛道的主播统一榜单，直播状态一目了然，点开就能追。',
  },
  {
    id: 3,
    icon: 'ri-file-list-3-line',
    title: '无删减合集整理',
    desc: '长篇内容按主题打包成合集，完整版顺序播放，省去一集一集寻找的麻烦。',
  },
  {
    id: 4,
    icon: 'ri-discuss-line',
    title: '社区一起聊',
    desc: '每个作品都有讨论区，可以聊观感、找同好、补充背景资料，看片不再是一个人的事。',
  },
];

export const categories = ['全部', '搞笑', '生活', '美食', '游戏', '音乐', '影视', '知识'];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '《城中村的清晨》：一碗热干面开始的一天',
    creator: '阿良的日常',
    category: '生活',
    duration: '08:24',
    views: '128.6万',
    likes: '3.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20early%20morning%20street%20in%20an%20old%20Chinese%20neighborhood%20alley%20with%20steam%20rising%20from%20a%20small%20noodle%20breakfast%20stall%2C%20soft%20golden%20sunrise%20light%2C%20cozy%20documentary%20photography%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones&width=800&height=450&seq=dv-video-01&orientation=landscape',
    desc: '跟拍一位早餐摊主从凌晨四点备料到早高峰收摊的全过程，记录城市醒来前的两个小时。',
    badge: '本周热榜',
  },
  {
    id: 2,
    title: '街头吉他手即兴改编《夜空中最亮的星》',
    creator: '音乐现场日记',
    category: '音乐',
    duration: '05:12',
    views: '96.4万',
    likes: '2.7万',
    cover:
      'https://readdy.ai/api/search-image?query=Street%20musician%20playing%20acoustic%20guitar%20at%20dusk%20in%20a%20city%20plaza%2C%20warm%20string%20lights%20bokeh%20behind%2C%20cinematic%20mood%2C%20documentary%20style%2C%20rich%20amber%20and%20golden%20tones&width=800&height=450&seq=dv-video-02&orientation=landscape',
    desc: '一段被路人围观的广场演出，副歌部分现场观众自发合唱，收尾掌声持续了近三十秒。',
  },
  {
    id: 3,
    title: '用100小时还原一座纸板城市',
    creator: '手作老张',
    category: '知识',
    duration: '22:08',
    views: '74.1万',
    likes: '1.9万',
    cover:
      'https://readdy.ai/api/search-image?query=Handmade%20miniature%20cardboard%20city%20model%20on%20a%20wooden%20table%20with%20tiny%20craft%20tools%20around%2C%20soft%20studio%20light%2C%20top-down%20craft%20photography%2C%20warm%20neutral%20background&width=800&height=450&seq=dv-video-03&orientation=landscape',
    desc: '从一张平面草图到能亮灯的立体街区，完整呈现缩放模型在结构与灯光上的取舍思路。',
    badge: '深度长片',
  },
  {
    id: 4,
    title: '猫咪第一次见到雪是什么反应',
    creator: '橘座日记',
    category: '搞笑',
    duration: '03:26',
    views: '210.3万',
    likes: '6.8万',
    cover:
      'https://readdy.ai/api/search-image?query=Cute%20orange%20tabby%20cat%20standing%20in%20soft%20fresh%20snow%20in%20a%20quiet%20courtyard%2C%20playful%20curious%20expression%2C%20gentle%20winter%20daylight%2C%20shallow%20depth%20of%20field%2C%20warm%20cozy%20tone&width=800&height=450&seq=dv-video-04&orientation=landscape',
    desc: '三分钟纯快乐，从试探性地踩出第一个脚印，到在雪地里打滚不肯回家。',
    badge: '爆款',
  },
  {
    id: 5,
    title: '深夜厨房：十分钟搞定一碗阳春面',
    creator: '深夜食堂阿杰',
    category: '美食',
    duration: '06:47',
    views: '88.9万',
    likes: '2.4万',
    cover:
      'https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20simple%20scallion%20noodles%20on%20a%20dark%20wooden%20kitchen%20counter%20at%20night%2C%20warm%20hanging%20lamp%20light%2C%20cozy%20food%20photography%2C%20rich%20amber%20tones&width=800&height=450&seq=dv-video-05&orientation=landscape',
    desc: '只用一口锅、一把挂面和两棵小葱，讲清楚「一碗好面靠的是汤头和油温」这件事。',
  },
  {
    id: 6,
    title: '高原自驾第7天：翻越海拔5000米垭口',
    creator: '陆上行舟',
    category: '生活',
    duration: '18:32',
    views: '65.7万',
    likes: '1.6万',
    cover:
      'https://readdy.ai/api/search-image?query=Lone%20off-road%20vehicle%20on%20winding%20mountain%20pass%20road%20at%20high%20altitude%20with%20dramatic%20clouds%2C%20vast%20plateau%20landscape%2C%20cinematic%20travel%20photography%2C%20warm%20golden%20light&width=800&height=450&seq=dv-video-06&orientation=landscape',
    desc: '连续上坡两个小时，发动机温度、胎压与高反，把一天的路况和心情都留在了镜头里。',
  },
  {
    id: 7,
    title: '方言配音挑战：四川话版经典片段',
    creator: '方言社',
    category: '搞笑',
    duration: '04:58',
    views: '154.2万',
    likes: '4.9万',
    cover:
      'https://readdy.ai/api/search-image?query=Retro%20microphone%20in%20a%20small%20colorful%20voice%20recording%20studio%20with%20soundproof%20foam%20panels%2C%20warm%20practical%20lights%2C%20playful%20creative%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=dv-video-07&orientation=landscape',
    desc: '同一段画面配四个地区的方言，评论区已经为了「哪版最传神」吵了三千多条。',
  },
  {
    id: 8,
    title: '独立游戏《山与海》通关全记录',
    creator: '老K打游戏',
    category: '游戏',
    duration: '41:15',
    views: '52.8万',
    likes: '1.3万',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20gaming%20setup%20with%20monitor%20showing%20a%20serene%20indie%20adventure%20game%20landscape%2C%20controller%20on%20desk%2C%20warm%20ambient%20backlight%2C%20moody%20editorial%20tech%20photography&width=800&height=450&seq=dv-video-08&orientation=landscape',
    desc: '全程无剪辑的完整通关流程，包含了三处容易被忽略的隐藏结局触发点。',
    badge: '完整版',
  },
  {
    id: 9,
    title: '一个人住第1000天，我家变成了什么样',
    creator: '独居观察',
    category: '生活',
    duration: '12:03',
    views: '137.5万',
    likes: '3.6万',
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20minimal%20small%20apartment%20living%20room%20with%20plants%2C%20wooden%20furniture%20and%20warm%20afternoon%20sunlight%20through%20the%20window%2C%20cozy%20interior%20lifestyle%20photography&width=800&height=450&seq=dv-video-09&orientation=landscape',
    desc: '把三年里添置、扔掉和一直留下的物件摊开，聊聊独居生活真正的成本与自由。',
  },
  {
    id: 10,
    title: '影视混剪：那些年我们追过的港片',
    creator: '光影笔记',
    category: '影视',
    duration: '09:41',
    views: '118.0万',
    likes: '3.1万',
    cover:
      'https://readdy.ai/api/search-image?query=Collection%20of%20vintage%20film%20reels%20and%20old%20movie%20posters%20on%20a%20warm%20wooden%20desk%2C%20dramatic%20warm%20lamp%20light%2C%20nostalgic%20cinema%20atmosphere%2C%20editorial%20still%20life&width=800&height=450&seq=dv-video-10&orientation=landscape',
    desc: '按年代梳理经典桥段的视听语言，逐段标注了配乐与剪辑节奏上的巧思。',
  },
  {
    id: 11,
    title: '钢琴改编：热门歌曲温柔串烧',
    creator: '琴键上的猫',
    category: '音乐',
    duration: '07:18',
    views: '79.4万',
    likes: '2.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Grand%20piano%20keys%20close%20up%20in%20a%20warm%20dim%20music%20room%2C%20soft%20golden%20rim%20light%2C%20elegant%20cinematic%20music%20photography%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=dv-video-11&orientation=landscape',
    desc: '把八首热门旋律无缝串成一首曲子，附上每段的调性变化说明，适合当背景音乐循环。',
  },
  {
    id: 12,
    title: '三分钟看懂黑洞照片是怎么拍出来的',
    creator: '科学放映室',
    category: '知识',
    duration: '05:33',
    views: '102.7万',
    likes: '2.9万',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20artistic%20space%20illustration%20of%20a%20glowing%20black%20hole%20accretion%20disk%20with%20warm%20orange%20and%20gold%20tones%20against%20deep%20dark%20background%2C%20digital%20art%2C%20dramatic%20and%20clean&width=800&height=450&seq=dv-video-12&orientation=landscape',
    desc: '用动画解释「地球那么大的一台望远镜」是怎么协作工作的，全程没有复杂公式。',
  },
];

export const streamers: StreamerItem[] = [
  {
    id: 1,
    name: '榴莲阿福',
    tagline: '综艺整活与即兴互动，擅长把冷场救成名场面',
    category: '综艺娱乐',
    heat: 98,
    followers: '186.4万',
    avatar:
      'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20male%20host%20portrait%20smiling%20warmly%20in%20a%20bright%20studio%2C%20simple%20soft%20orange%20background%2C%20clean%20editorial%20portrait%20photography%2C%20warm%20natural%20light&width=400&height=400&seq=dv-host-01&orientation=squarish',
    live: true,
    tags: ['整活', '连麦', '日更'],
  },
  {
    id: 2,
    name: '晚风Radio',
    tagline: '深夜音乐电台，点歌与故事投稿的固定栏目',
    category: '音乐电台',
    heat: 94,
    followers: '142.7万',
    avatar:
      'https://readdy.ai/api/search-image?query=Cozy%20young%20female%20radio%20host%20wearing%20headphones%20in%20a%20warm%20dim%20studio%2C%20simple%20soft%20golden%20background%2C%20editorial%20portrait%20photography%2C%20warm%20lamp%20light&width=400&height=400&seq=dv-host-02&orientation=squarish',
    live: true,
    tags: ['点歌', '治愈', '深夜'],
  },
  {
    id: 3,
    name: '老周说片',
    tagline: '不剧透的影视解说，擅长拆结构与镜头语言',
    category: '影视解说',
    heat: 91,
    followers: '128.1万',
    avatar:
      'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20male%20film%20reviewer%20with%20glasses%20talking%20to%20camera%2C%20simple%20warm%20neutral%20background%2C%20clean%20editorial%20portrait%2C%20soft%20studio%20light&width=400&height=400&seq=dv-host-03&orientation=squarish',
    live: false,
    tags: ['解说', '影单', '周更'],
  },
  {
    id: 4,
    name: '小满厨房',
    tagline: '家常菜直播，边做边讲失败案例怎么补救',
    category: '美食',
    heat: 88,
    followers: '97.5万',
    avatar:
      'https://readdy.ai/api/search-image?query=Young%20female%20chef%20in%20a%20linen%20apron%20smiling%20in%20a%20warm%20home%20kitchen%2C%20simple%20soft%20golden%20background%2C%20cozy%20editorial%20portrait%20photography%2C%20warm%20light&width=400&height=400&seq=dv-host-04&orientation=squarish',
    live: true,
    tags: ['做饭', '教学', '直播'],
  },
  {
    id: 5,
    name: '电竞橘子',
    tagline: '赛事复盘与排位直播，节奏快、术语讲得明白',
    category: '游戏赛事',
    heat: 85,
    followers: '110.9万',
    avatar:
      'https://readdy.ai/api/search-image?query=Young%20esports%20player%20wearing%20a%20gaming%20headset%20looking%20confident%2C%20simple%20warm%20amber%20background%2C%20clean%20editorial%20portrait%20photography%2C%20studio%20light&width=400&height=400&seq=dv-host-05&orientation=squarish',
    live: false,
    tags: ['赛事', '复盘', '排位'],
  },
  {
    id: 6,
    name: '山野漫游者',
    tagline: '户外与自驾路线分享，装备清单都是实拍实测',
    category: '户外旅行',
    heat: 82,
    followers: '76.3万',
    avatar:
      'https://readdy.ai/api/search-image?query=Outdoorsy%20traveler%20with%20a%20backpack%20and%20warm%20jacket%20at%20golden%20sunset%20on%20a%20hilltop%2C%20simple%20warm%20sky%20background%2C%20documentary%20portrait%20photography&width=400&height=400&seq=dv-host-06&orientation=squarish',
    live: false,
    tags: ['户外', '自驾', '攻略'],
  },
];

export const collections: CollectionItem[] = [
  {
    id: 1,
    title: '完整版纪录片合集',
    count: '共 48 部 · 持续更新',
    desc: '按照自然、人文、工业三个方向整理的长片合集，统一标注片长与更新日期，适合一次看个够。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20themed%20still%20with%20a%20vintage%20camera%20lens%20and%20film%20canisters%20on%20a%20warm%20wooden%20surface%2C%20soft%20golden%20light%2C%20editorial%20composition%2C%20warm%20neutral%20tones&width=600&height=750&seq=dv-col-01&orientation=portrait',
    badge: '完整版',
    samples: ['城市边缘的一天（52 分钟）', '手艺人的最后一把刻刀', '高原上的信号塔', '返乡村医的十年'],
  },
  {
    id: 2,
    title: '未删减影视混剪精选',
    count: '共 126 条 · 每周新增',
    desc: '收录保留完整片段的混剪作品，逐条注明出处与时间轴，想顺着原片看下去也很方便。',
    cover:
      'https://readdy.ai/api/search-image?query=Stack%20of%20old%20movie%20posters%20and%20film%20strips%20with%20warm%20amber%20lighting%20on%20a%20dark%20table%2C%20nostalgic%20cinema%20atmosphere%2C%20editorial%20still%20life%2C%20rich%20warm%20tones&width=600&height=750&seq=dv-col-02&orientation=portrait',
    badge: '无删减',
    samples: ['港片黄金年代混剪（含完整段落）', '长镜头美学合集', '被剪掉的结尾们', '配乐与画面的十二个瞬间'],
  },
  {
    id: 3,
    title: '主播连麦全程回放',
    count: '共 73 场 · 按场次归档',
    desc: '把多主播连麦的整场直播剪成可回看的回放，去掉等待片段，保留所有互动与名场面。',
    cover:
      'https://readdy.ai/api/search-image?query=Podcast%20studio%20scene%20with%20microphones%20and%20headphones%20on%20a%20warm%20wooden%20desk%2C%20soft%20amber%20practical%20lights%2C%20cozy%20editorial%20photography%2C%20warm%20tones&width=600&height=750&seq=dv-col-03&orientation=portrait',
    badge: '回放',
    samples: ['阿福 × 晚风Radio 双人连麦', '老周说片 影视夜话专场', '小满厨房 深夜下饭场', '电竞橘子 赛后复盘连麦'],
  },
  {
    id: 4,
    title: '长篇手作全流程合集',
    count: '共 39 集 · 完整收录',
    desc: '从开料、打样到成品的完整流程合辑，每一步都有讲解，适合当学习资料慢慢看。',
    cover:
      'https://readdy.ai/api/search-image?query=Woodworking%20craft%20workshop%20bench%20with%20hand%20tools%20and%20wood%20shavings%20under%20soft%20golden%20light%2C%20warm%20artisan%20editorial%20photography%2C%20neutral%20tones&width=600&height=750&seq=dv-col-04&orientation=portrait',
    badge: '合集',
    samples: ['橡木小凳全流程（12 集）', '从图纸到成品：木质收纳盒', '手工皮具入门 8 讲', '旧家具修复的完整记录'],
  },
];

export const guideSteps: GuideStep[] = [
  {
    step: '01',
    title: '先看今日热门榜',
    desc: '首屏的热门推荐按互动热度实时排序，直接点开想看的卡片即可进入播放区，不需要注册。',
    icon: 'ri-list-check-2',
  },
  {
    step: '02',
    title: '按分类或标签筛选',
    desc: '在热门推荐或合集区使用分类标签，把搞笑、生活、美食、游戏等类型单独筛出来，页面只显示本页已有内容。',
    icon: 'ri-filter-3-line',
  },
  {
    step: '03',
    title: '追踪喜欢的主播',
    desc: '在福利主播榜单里查看主播的赛道、更新频率与直播状态，挑选几位固定追更，形成自己的观看节奏。',
    icon: 'ri-user-heart-line',
  },
  {
    step: '04',
    title: '在社区留下想法',
    desc: '看完之后到社区讨论区翻翻同好的评价，或补充你发现的细节，好内容往往是被讨论出来的。',
    icon: 'ri-chat-3-line',
  },
];

export const discussions: DiscussionItem[] = [
  {
    id: 1,
    author: '夜航船',
    initial: '夜',
    title: '《城中村的清晨》里那个挑面的手法，有人知道叫什么吗？',
    board: '生活记录',
    excerpt: '看了两遍都觉得那个动作特别利落，想找教程学一下，有懂行的朋友吗……',
    replies: 128,
    likes: 342,
    time: '2 小时前',
  },
  {
    id: 2,
    author: '橘猫观察员',
    initial: '橘',
    title: '求推荐适合睡前看的音乐现场，节奏不要太快',
    board: '音乐现场',
    excerpt: '最近失眠，发现听那种小场地演出的视频特别放松，收集一下大家的私藏……',
    replies: 96,
    likes: 517,
    time: '5 小时前',
  },
  {
    id: 3,
    author: '光影拾忆',
    initial: '光',
    title: '港片混剪里第 4 分钟那段配乐，出处整理好了',
    board: '影视杂谈',
    excerpt: '作者在评论区回复过一部分，我把剩下的补全了，按出现顺序列在这里……',
    replies: 74,
    likes: 289,
    time: '8 小时前',
  },
  {
    id: 4,
    author: '打游戏的老K',
    initial: 'K',
    title: '《山与海》隐藏结局的第三个触发点讨论',
    board: '游戏交流',
    excerpt: '视频里说第三个触发点在二周目，我实测一周目也能触发，条件是……',
    replies: 203,
    likes: 668,
    time: '1 天前',
  },
  {
    id: 5,
    author: '深夜一碗面',
    initial: '面',
    title: '阳春面的汤头到底要不要放猪油，来投票',
    board: '美食厨房',
    excerpt: '按视频里的做法试了两次，放与不放差别挺大，想看看大家的习惯……',
    replies: 156,
    likes: 421,
    time: '1 天前',
  },
  {
    id: 6,
    author: '高原的风',
    initial: '风',
    title: '自驾翻垭口那段，胎压调整的经验补充',
    board: '户外旅行',
    excerpt: '补充一点视频里没展开的细节，海拔每升高一千米大概要这样处理……',
    replies: 61,
    likes: 197,
    time: '2 天前',
  },
];

export const tags: TagItem[] = [
  { id: 1, label: '热干面', count: '3,820' },
  { id: 2, label: '街头吉他', count: '2,105' },
  { id: 3, label: '纸板模型', count: '986' },
  { id: 4, label: '猫咪', count: '6,404' },
  { id: 5, label: '阳春面', count: '1,532' },
  { id: 6, label: '高原自驾', count: '523' },
  { id: 7, label: '方言配音', count: '1,742' },
  { id: 8, label: '独立游戏', count: '2,318' },
  { id: 9, label: '独居', count: '1,905' },
  { id: 10, label: '港片', count: '1,417' },
  { id: 11, label: '钢琴', count: '1,264' },
  { id: 12, label: '黑洞', count: '978' },
];

export const faqs: FaqItem[] = [
  {
    id: 1,
    q: '榴莲视频这个页面是做什么的？',
    a: '这是一个内容导览页面，把热门推荐、福利主播榜单、无删减合集和社区讨论集中整理在一起。它的作用是帮你更快找到感兴趣的短视频与主播，而不是提供一个视频播放网站。',
  },
  {
    id: 2,
    q: '需要注册或登录才能浏览吗？',
    a: '不需要。本页所有内容在打开时就已经完整呈现，分类筛选、标签切换和问答展开都只作用于当前页面已有的内容，不涉及账号系统。',
  },
  {
    id: 3,
    q: '页面上的内容是免费的吗？',
    a: '本页只做信息整理与推荐说明，不提供付费项目，也不会发起任何真实提交。你看到的是分类、榜单与讨论的展示结构，用于帮助你判断想看什么。',
  },
  {
    id: 4,
    q: '怎么看「无删减」和「完整版」的内容？',
    a: '在无删减合集区按主题选择对应合集，条目里会标注片长与更新情况。筛选用的是本页已有的内容标签，切换后列表会即时更新，方便你按主题连续观看。',
  },
  {
    id: 5,
    q: '手机上看会不会很乱？',
    a: '页面在手机上会把多列卡片自动收成单列，横向的标签栏可以左右滑动，文字与按钮保持合适的尺寸，密排的内容也尽量做到可读、可点。',
  },
  {
    id: 6,
    q: '内容多久更新一次？',
    a: '热门推荐与主播榜单按照固定节奏整理，一般在每天固定时段刷新；合集区通常是持续追加。具体更新以页面上的标注与说明为准。',
  },
];

export const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '热门推荐', href: '#hot' },
      { label: '福利主播', href: '#streamers' },
      { label: '无删减合集', href: '#collections' },
      { label: '热门标签', href: '#tags' },
    ],
  },
  {
    title: '使用帮助',
    links: [
      { label: '观看指南', href: '#guide' },
      { label: '常见问题', href: '#faq' },
      { label: '社区讨论', href: '#community' },
      { label: '本站简介', href: '#intro' },
    ],
  },
];